var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGynecologist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6996,
    cy: 62.8325,
    r: 62.8325,
    fill: "url(#paint0_linear_4741_2340)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4741_2340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 127,
    height: 126
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6996,
    cy: 62.8325,
    r: 62.8325,
    fill: "url(#paint1_linear_4741_2340)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4741_2340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6711 65.8867H64.7106C59.4815 65.8867 54.9902 70.3809 54.9902 75.6071V130.695H86.0616V104.576L87.3944 99.4662V75.6071C87.3944 70.378 82.9002 65.8867 77.6711 65.8867Z",
    fill: "#577CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6492 73.8262C62.1685 73.8262 58.8305 75.2089 56.3693 77.67C53.9081 80.1312 52.5254 83.4693 52.5254 86.95C52.5254 90.4306 53.9081 93.7687 56.3693 96.2299C58.8305 98.6911 62.1685 100.074 65.6492 100.074V73.8262Z",
    fill: "#0072DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6508 76.7422C62.9436 76.7422 60.3473 77.8176 58.433 79.7319C56.5188 81.6461 55.4434 84.2424 55.4434 86.9496C55.4434 89.6568 56.5188 92.2531 58.433 94.1673C60.3473 96.0816 62.9436 97.157 65.6508 97.157V76.7422Z",
    fill: "#577CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4832 73.8262C68.0025 73.8262 64.6644 75.2089 62.2032 77.67C59.7421 80.1312 58.3594 83.4693 58.3594 86.95C58.3594 90.4306 59.7421 93.7687 62.2032 96.2299C64.6644 98.6911 68.0025 100.074 71.4832 100.074V73.8262Z",
    fill: "#0072DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4828 76.7422C68.7756 76.7422 66.1793 77.8176 64.2651 79.7319C62.3508 81.6461 61.2754 84.2424 61.2754 86.9496C61.2754 89.6568 62.3508 92.2531 64.2651 94.1673C66.1793 96.0816 68.7756 97.157 71.4828 97.157V76.7422Z",
    fill: "#577CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6082 130.695H68.4722V89.136C67.1324 88.9019 65.7755 88.78 64.4155 88.7715C57.9592 88.7715 51.7675 91.3362 47.2022 95.9014C42.637 100.467 40.0723 106.658 40.0723 113.115C40.0723 120.032 42.9712 126.262 47.6082 130.695Z",
    fill: "#0072DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9517 78.6986V91.7962C66.7833 91.5926 65.6001 91.4863 64.4141 91.4783C61.5726 91.4779 58.7589 92.0373 56.1336 93.1245C53.5084 94.2117 51.123 95.8055 49.1138 97.8147C47.1045 99.8239 45.5108 102.209 44.4236 104.835C43.3364 107.46 42.777 110.274 42.7773 113.115C42.7776 116.555 43.5995 119.945 45.1746 123.002C46.7497 126.06 49.0324 128.698 51.8328 130.695H83.0266V70.4219L67.9517 78.6986Z",
    fill: "#577CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4268 72.3672L98.5714 87.2817L86.0659 100.438L86.06 109.321L74.5694 117.119L66.8672 105.048L83.3303 88.1041L77.6754 82.4958L84.4268 72.3672Z",
    fill: "#0072DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4233 68.7207L100.359 85.3267C100.359 85.3267 105.891 89.7829 100.359 95.0471C97.0368 98.2055 76.2224 112.225 76.2224 112.225L69.7422 105.744L87.3981 88.5668L77.6748 78.8464L84.4233 68.7207Z",
    fill: "#577CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4473 105.996C69.1693 104.436 66.0604 104.651 63.0536 106.41C61.6158 107.253 61.0296 108.828 63.2315 109.35C65.4421 109.866 72.4473 105.996 72.4473 105.996Z",
    fill: "#EEC2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8659 111.589C77.2713 116.737 70.374 121.546 65.142 120.919C61.4032 120.47 58.1485 110.396 62.5843 109.098C66.5389 107.944 67.6326 104.351 72.3251 105.692C76.0522 106.76 76.7172 109.612 76.8659 111.589Z",
    fill: "#F7DECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4059 113.58L72.7876 112.294C72.7876 112.294 70.5391 115.639 67.4127 116.931C65.0416 117.899 63.0439 117.995 61.9969 117.823C62.446 118.678 62.4548 118.824 63.0439 119.369C66.3015 119.483 71.5073 117.736 73.4059 113.58ZM66.9402 113.466C69.8274 111.489 70.6703 109.599 70.6703 109.599L69.7283 108.406C69.7283 108.406 66.389 113.586 60.4629 113.32C60.5066 114.044 60.4483 114.184 60.6612 114.924C61.4574 114.951 64.5954 115.07 66.9402 113.466Z",
    fill: "#E0AA94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5734 39.7291C58.9748 40.6838 59.1841 41.7083 59.1893 42.744C59.1946 43.7796 58.9957 44.8062 58.6041 45.7649C58.2125 46.7237 57.6357 47.5959 56.9069 48.3317C56.178 49.0675 55.3113 49.6525 54.3563 50.0531C53.3983 50.4479 52.3719 50.6499 51.3358 50.6478C50.2997 50.6456 49.2742 50.4393 48.3178 50.0406C47.3615 49.6419 46.4931 49.0587 45.7622 48.3242C45.0314 47.5898 44.4524 46.7185 44.0585 45.7602C43.6573 44.8051 43.4483 43.7803 43.4434 42.7444C43.4386 41.7085 43.6379 40.6817 44.0301 39.7229C44.4223 38.7641 44.9997 37.892 45.7291 37.1564C46.4586 36.4209 47.3259 35.8363 48.2814 35.4361C49.239 35.0416 50.265 34.8396 51.3007 34.8418C52.3364 34.844 53.3615 35.0504 54.3173 35.4491C55.2732 35.8478 56.1411 36.4311 56.8714 37.1655C57.6017 37.8998 58.1801 38.771 58.5734 39.7291Z",
    fill: "#292F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3517 60.1137C77.8601 55.9286 79.9541 50.58 78.1547 46.2579L75.1799 39.0923C59.0989 45.1467 52.4816 36.8379 52.4816 36.8379C52.4816 36.8379 55.6313 44.4147 48.8711 48.2731L52.467 56.929C55.4067 63.9983 59.4139 69.0612 66.4745 66.1594L66.7136 67.1101C67.3144 69.4928 66.874 71.4206 70.3825 71.5547C72.8352 71.648 76.1482 67.2676 75.5474 64.8849L74.3517 60.1137Z",
    fill: "#F7DECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0947 41.4866C95.4978 35.0647 89.7146 30.1826 84.7917 29.681C81.8053 29.3777 79.1106 31.2821 77.7982 33.5627C71.8166 23.5478 62.8691 25.9072 57.1763 27.9107C51.1452 30.0339 42.1743 36.2779 45.6944 42.9885C49.2145 49.7021 60.9705 46.8149 60.9705 46.8149L65.2256 53.6742C64.0765 47.7714 67.9961 46.4532 69.8072 47.7394C71.7146 49.0955 70.4488 53.4438 71.3179 55.1587C72.187 56.8735 75.1967 59.2241 75.1967 59.2241C77.0457 56.8735 82.8815 48.7893 80.1546 38.9989C81.2833 38.576 82.9777 38.8618 84.3455 39.5763C87.8218 41.3816 85.0833 50.3758 89.9187 53.2193C94.5529 55.9461 97.271 52.1956 97.271 52.1956C92.5231 52.3531 90.7995 47.6256 93.0947 41.4866Z",
    fill: "#292F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9818 60.0637L54.0836 60.437C53.9895 60.479 53.8879 60.5017 53.7849 60.5038C53.6818 60.5059 53.5794 60.4874 53.4836 60.4494C53.3878 60.4113 53.3006 60.3545 53.2271 60.2823C53.1537 60.21 53.0954 60.1238 53.0557 60.0287C53.016 59.9336 52.9957 59.8315 52.9961 59.7284C52.9965 59.6254 53.0174 59.5234 53.0578 59.4286C53.0981 59.3337 53.157 59.2479 53.231 59.1762C53.305 59.1045 53.3926 59.0483 53.4886 59.0109L54.3898 58.6376C54.4844 58.5932 54.5869 58.5685 54.6913 58.5649C54.7956 58.5613 54.8996 58.5789 54.997 58.6166C55.0944 58.6543 55.1831 58.7113 55.2578 58.7843C55.3326 58.8572 55.3917 58.9445 55.4318 59.041C55.4718 59.1374 55.4919 59.241 55.4908 59.3454C55.4897 59.4498 55.4675 59.5529 55.4254 59.6485C55.3834 59.7441 55.3224 59.8302 55.2461 59.9015C55.1699 59.9729 55.08 60.0281 54.9818 60.0637Z",
    fill: "#BF6952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4238 54.0241C55.0455 54.1807 54.6206 54.1808 54.2422 54.0244C53.8639 53.868 53.563 53.568 53.4057 53.19L52.8078 51.758C52.6504 51.379 52.65 50.953 52.8067 50.5737C52.9634 50.1944 53.2643 49.8929 53.6433 49.7355C54.0223 49.5781 54.4484 49.5777 54.8277 49.7344C55.2069 49.8911 55.5085 50.1921 55.6659 50.5711L56.2608 52.0001C56.3392 52.1879 56.3797 52.3893 56.38 52.5928C56.3803 52.7963 56.3404 52.9979 56.2627 53.1859C56.1849 53.374 56.0708 53.5448 55.9268 53.6887C55.7829 53.8325 55.6119 53.9465 55.4238 54.0241Z",
    fill: "#662113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2051 63.5655C56.9138 64.4259 57.6895 65.1433 58.5265 65.7033C61.6033 63.9272 61.8192 61.2324 61.8192 61.2324L56.3509 63.5043L56.2051 63.5655Z",
    fill: "#DF1F32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4741_2340",
    x1: 63.6996,
    y1: 0,
    x2: 63.6996,
    y2: 125.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4741_2340",
    x1: 63.6996,
    y1: 0,
    x2: 63.6996,
    y2: 125.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGynecologist);
export default __webpack_public_path__ + "static/media/Gynecologist.7a09bf4b68eec87cd218cff1ef9a3788.svg";
export { ForwardRef as ReactComponent };